/**
 * @generated SignedSource<<88a72475ee59660eecda0e6ecb248552>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveTemplateMutation$variables = {
  name: string;
};
export type RemoveTemplateMutation$data = {
  readonly removeTemplate: string | null | undefined;
};
export type RemoveTemplateMutation = {
  response: RemoveTemplateMutation$data;
  variables: RemoveTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  }
],
v2 = {
  "alias": null,
  "args": (v1/*:: as any*/),
  "kind": "ScalarField",
  "name": "removeTemplate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveTemplateMutation",
    "selections": [
      (v2/*:: as any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "RemoveTemplateMutation",
    "selections": [
      (v2/*:: as any*/),
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "filters": null,
        "handle": "deleteRecord",
        "key": "",
        "kind": "ScalarHandle",
        "name": "removeTemplate"
      }
    ]
  },
  "params": {
    "cacheID": "1ac6cd6b7922166e5e8acb90c3fb7708",
    "id": null,
    "metadata": {},
    "name": "RemoveTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveTemplateMutation(\n  $name: String!\n) {\n  removeTemplate(name: $name)\n}\n"
  }
};
})();

(node as any).hash = "596d184f47b893136f74fe8061310478";

export default node;
